import { render, staticRenderFns } from "./transcript-platform-badge.vue?vue&type=template&id=26fbbdaa&"
import script from "./transcript-platform-badge.vue?vue&type=script&lang=js&"
export * from "./transcript-platform-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26fbbdaa')) {
      api.createRecord('26fbbdaa', component.options)
    } else {
      api.reload('26fbbdaa', component.options)
    }
    module.hot.accept("./transcript-platform-badge.vue?vue&type=template&id=26fbbdaa&", function () {
      api.rerender('26fbbdaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/transcript-platform-badge/transcript-platform-badge.vue"
export default component.exports